/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetMembersQueryResponse, HierarchiesControllerGetMembersPathParams, HierarchiesControllerGetMembersQueryParams, HierarchiesControllerGetMembers401, HierarchiesControllerGetMembers403 } from "../../models/hierarchiesController/HierarchiesControllerGetMembers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { hierarchiesControllerGetMembers } from "../../clients/hierarchiesService/hierarchiesControllerGetMembers";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const hierarchiesControllerGetMembersQueryKey = (scopeId: HierarchiesControllerGetMembersPathParams["scopeId"], params: HierarchiesControllerGetMembersQueryParams = {}) => [{
  url: '/api/v1/hierarchies/:scopeId/members',
  params: {
    scopeId: scopeId
  }
}, ...(params ? [params] : [])] as const;
export type HierarchiesControllerGetMembersQueryKey = ReturnType<typeof hierarchiesControllerGetMembersQueryKey>;
export function hierarchiesControllerGetMembersQueryOptions(scopeId: HierarchiesControllerGetMembersPathParams["scopeId"], params?: HierarchiesControllerGetMembersQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = hierarchiesControllerGetMembersQueryKey(scopeId, params);
  return queryOptions<HierarchiesControllerGetMembersQueryResponse, ResponseErrorConfig<HierarchiesControllerGetMembers401 | HierarchiesControllerGetMembers403>, HierarchiesControllerGetMembersQueryResponse, typeof queryKey>({
    enabled: !!scopeId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return hierarchiesControllerGetMembers(scopeId, params, config);
    }
  });
}

/**
 * @description Retrieve all members (users) of a scope with membership metadata as extensions
 * @summary Get scope members
 * {@link /api/v1/hierarchies/:scopeId/members}
 */
export function useHierarchiesControllerGetMembers<TData = HierarchiesControllerGetMembersQueryResponse, TQueryData = HierarchiesControllerGetMembersQueryResponse, TQueryKey extends QueryKey = HierarchiesControllerGetMembersQueryKey>(scopeId: HierarchiesControllerGetMembersPathParams["scopeId"], params?: HierarchiesControllerGetMembersQueryParams, options: {
  query?: Partial<QueryObserverOptions<HierarchiesControllerGetMembersQueryResponse, ResponseErrorConfig<HierarchiesControllerGetMembers401 | HierarchiesControllerGetMembers403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? hierarchiesControllerGetMembersQueryKey(scopeId, params);
  const query = useQuery({
    ...hierarchiesControllerGetMembersQueryOptions(scopeId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<HierarchiesControllerGetMembers401 | HierarchiesControllerGetMembers403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}